import { hiEducIcon, midEducIcon } from '@/images'
import { TypeLoadData } from '@/interfaces/Fetcher'
import { GxForm, GxIcon } from '@garpix/garpix-web-components-react'
import React, { useState } from 'react'
import { levelValues } from '../const'
import style from '../styles/best.module.scss'
import InstitutionsButton from './InstitutionsButton'
import SpecialsSelect from './SpecialsSelect'
import StateSelect from './StateSelect'

interface IProps {
  handleFilter: TypeLoadData
  initFilters: any
}

const InstitutionsFilters = ({ handleFilter, initFilters }: IProps): React.ReactElement => {
  const [filter, setFilter] = useState({
    page_size: initFilters.page_size,
    level: initFilters.level,
    region: '',
    special: ''
  })

  const onSubmit = (): void => handleFilter(1, filter)

  const handleLevel = (value): void => {
    const newValue = { ...filter, level: value }
    setFilter(newValue)
    handleFilter(1, newValue)
  }

  const handleChange = (e): void => {
    const newValue = { ...filter, [e.target.name]: e.target.value }
    setFilter(newValue)
    handleFilter(1, newValue)
  }

  return (
    <GxForm onGx-submit={onSubmit}>
      <div className={style.filters}>
        <div className={style.filters_buttons}>
          <InstitutionsButton
            checked={filter.level === levelValues.secondary}
            onClick={() => handleLevel(levelValues.secondary)}
          >
            <GxIcon src={midEducIcon} className={style.filters__icon} />
            Среднее образование
          </InstitutionsButton>
          <InstitutionsButton
            checked={filter.level === levelValues.higher}
            onClick={() => handleLevel(levelValues.higher)}
          >
            <GxIcon src={hiEducIcon} className={style.filters__icon} />
            Высшее образование
          </InstitutionsButton>
        </div>

        <div className={style.filters_selects}>
          <StateSelect
            label=''
            placeholder='Регион'
            theme='secondary'
            name='region'
            className={style.filters__select}
            value={filter.region}
            onGx-change={handleChange}
            clearable
          />
          <SpecialsSelect
            label=''
            placeholder='Специальность'
            theme='secondary'
            name='special'
            className={style.filters__select}
            value={filter.special}
            onGx-change={handleChange}
            clearable
          />
        </div>
      </div>
    </GxForm>
  )
}

export default InstitutionsFilters
